import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { InterfacePafRadioCheckbox } from './paf-radio-checkbox.custom';

@Component({
  shadow: false,
  styleUrl: 'paf-radio-checkbox.scss',
  tag: 'paf-radio-checkbox',
})

export class PafRadioCheckbox implements ComponentInterface {

  /**
   * Define if a checkbox or a radio should be rendered.
   */
  @Prop() public type!: InterfacePafRadioCheckbox['type'];

  /**
   * Define the value for the input ()
   */
  @Prop({
    reflect: true,
  }) public value!: string;

  /**
   * The name attribute for the input.
   */
  @Prop() public name!: string;

  /**
   * The text to show as label.
   */
  @Prop() public label!: string;

  /**
   * Define if it should be checked (selected respectively).
   */
  @Prop({
    mutable: true,
    reflect: true,
  }) public checked?: boolean;

  /**
   * Define if input should be disabled
   */
  @Prop({
    reflect: true,
  }) public disabled?: boolean;

  private _handleChange = (evt): void => {
    this.checked = evt.target.checked;
  };

  public render(): HTMLDivElement {

    const inputAttributes = {};

    if (this.checked) {
      inputAttributes['checked'] = true;
    }

    return (
      <div class='paf-radio-checkbox'>

        <input
          class='paf-radio-checkbox__input'
          type={this.type}
          name={this.name}
          value={this.value}
          id={this.value}
          disabled={this.disabled}
          {...inputAttributes}
          onChange={this._handleChange}
        />

        {this.type === 'checkbox' &&
          <svg
            viewBox='0 0 16 12'
            class='paf-radio-checkbox__checkmark'
            role='presentation'
          >
            <path d='M5.709 11.866.484 6.641l1.283-1.283L5.71 9.299 14.234.774l1.283 1.284-9.808 9.808Z'/>
          </svg>
        }

        {this.type === 'radio' &&
          <svg
            class='paf-radio-checkbox__circle'
            viewBox='0 0 16 16'
            role='presentation'
          >
            <circle r='8' cx='8' cy='8' />
          </svg>
        }

        <label
          htmlFor={this.value}
          class='paf-radio-checkbox__label'
        >
          {this.label}
        </label>
      </div>
    );
  }
}
